var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "709px",
    height: "709px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#d50037",
    d: "M 338.5,87.5 C 432.496,85.2586 508.663,120.592 567,193.5C 622.386,272.204 634.386,357.204 603,448.5C 567.023,535.804 503.19,590.971 411.5,614C 310.268,632.81 224.435,604.976 154,530.5C 93.4655,457.676 74.4655,375.009 97,282.5C 126.167,188 188,126.167 282.5,97C 301.037,92.1891 319.703,89.0224 338.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcecef",
    d: "M 216.5,332.5 C 229.5,332.5 242.5,332.5 255.5,332.5C 255.5,334.833 255.5,337.167 255.5,339.5C 241.753,338.862 228.253,339.529 215,341.5C 214.022,344.669 214.522,347.503 216.5,350C 227.93,350.043 239.263,350.71 250.5,352C 257.382,359.626 257.049,366.959 249.5,374C 236.171,374.5 222.837,374.667 209.5,374.5C 209.5,372.5 209.5,370.5 209.5,368.5C 222.504,368.667 235.504,368.5 248.5,368C 251.439,363.982 251.105,360.315 247.5,357C 236.5,356.667 225.5,356.333 214.5,356C 209.376,350.626 208.209,344.46 211,337.5C 212.73,335.598 214.563,333.931 216.5,332.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf1f3",
    d: "M 270.5,332.5 C 280.172,332.334 289.839,332.5 299.5,333C 302.196,333.69 304.363,335.19 306,337.5C 307.615,347.4 307.949,357.4 307,367.5C 306.654,369.848 305.487,371.681 303.5,373C 291.93,374.623 280.264,374.957 268.5,374C 264.835,372.332 262.668,369.499 262,365.5C 261.333,357.5 261.333,349.5 262,341.5C 263.714,337.29 266.547,334.29 270.5,332.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef9f9",
    d: "M 314.5,333.5 C 315.833,333.5 317.167,333.5 318.5,333.5C 318.172,344.014 318.506,354.347 319.5,364.5C 319.511,366.017 320.177,367.184 321.5,368C 334.496,368.5 347.496,368.667 360.5,368.5C 360.5,370.5 360.5,372.5 360.5,374.5C 346.402,374.965 332.402,374.465 318.5,373C 316.683,371.2 315.516,369.034 315,366.5C 314.5,355.505 314.333,344.505 314.5,333.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ea91a2",
    d: "M 314.5,333.5 C 315.919,332.549 317.585,332.216 319.5,332.5C 319.5,343.167 319.5,353.833 319.5,364.5C 318.506,354.347 318.172,344.014 318.5,333.5C 317.167,333.5 315.833,333.5 314.5,333.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdeff1",
    d: "M 366.5,333.5 C 368.167,333.5 369.833,333.5 371.5,333.5C 371.046,344.603 371.546,355.603 373,366.5C 373.5,367 374,367.5 374.5,368C 384.833,368.667 395.167,368.667 405.5,368C 406.308,367.692 406.975,367.192 407.5,366.5C 408.478,355.552 408.811,344.552 408.5,333.5C 410.167,333.5 411.833,333.5 413.5,333.5C 413.667,344.172 413.5,354.839 413,365.5C 412.332,369.499 410.165,372.332 406.5,374C 395.167,374.667 383.833,374.667 372.5,374C 369.246,371.658 367.412,368.491 367,364.5C 366.5,354.172 366.334,343.839 366.5,333.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf5f6",
    d: "M 426.5,367.5 C 425.711,367.783 425.044,368.283 424.5,369C 438.163,369.5 451.829,369.667 465.5,369.5C 465.5,371.167 465.5,372.833 465.5,374.5C 450.83,374.667 436.163,374.5 421.5,374C 418.923,370.595 418.923,367.262 421.5,364C 433.862,356.156 446.195,348.323 458.5,340.5C 459.289,340.217 459.956,339.717 460.5,339C 446.837,338.5 433.171,338.333 419.5,338.5C 419.5,336.5 419.5,334.5 419.5,332.5C 433.837,332.333 448.171,332.5 462.5,333C 466.105,336.315 466.439,339.982 463.5,344C 451.138,351.844 438.805,359.677 426.5,367.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e05571",
    d: "M 476.5,374.5 C 476.5,360.833 476.5,347.167 476.5,333.5C 475.167,333.5 473.833,333.5 472.5,333.5C 472.5,347.167 472.5,360.833 472.5,374.5C 471.504,360.677 471.171,346.677 471.5,332.5C 473.5,332.5 475.5,332.5 477.5,332.5C 477.829,346.677 477.496,360.677 476.5,374.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 476.5,374.5 C 475.167,374.5 473.833,374.5 472.5,374.5C 472.5,360.833 472.5,347.167 472.5,333.5C 473.833,333.5 475.167,333.5 476.5,333.5C 476.5,347.167 476.5,360.833 476.5,374.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcecef",
    d: "M 490.5,332.5 C 500.506,332.334 510.506,332.5 520.5,333C 524.896,333.73 527.73,336.23 529,340.5C 529.667,349.5 529.667,358.5 529,367.5C 527.542,369.96 525.709,372.127 523.5,374C 512.167,374.667 500.833,374.667 489.5,374C 486.619,372.749 484.786,370.583 484,367.5C 483.333,358.167 483.333,348.833 484,339.5C 485.694,336.642 487.861,334.309 490.5,332.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdf4f6",
    d: "M 577.5,333.5 C 578.833,333.5 580.167,333.5 581.5,333.5C 581.5,345.833 581.5,358.167 581.5,370.5C 580.538,374.146 578.205,375.313 574.5,374C 563.697,362.196 552.53,350.696 541,339.5C 540.5,351.162 540.333,362.829 540.5,374.5C 538.833,374.5 537.167,374.5 535.5,374.5C 535.333,362.162 535.5,349.829 536,337.5C 537.334,333.896 539.834,332.729 543.5,334C 554.303,345.804 565.47,357.304 577,368.5C 577.5,356.838 577.667,345.171 577.5,333.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e98fa0",
    d: "M 577.5,333.5 C 578.919,332.549 580.585,332.216 582.5,332.5C 582.829,345.344 582.495,358.011 581.5,370.5C 581.5,358.167 581.5,345.833 581.5,333.5C 580.167,333.5 578.833,333.5 577.5,333.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 588.5,333.5 C 589.833,333.5 591.167,333.5 592.5,333.5C 592.5,347.167 592.5,360.833 592.5,374.5C 591.167,374.5 589.833,374.5 588.5,374.5C 588.5,360.833 588.5,347.167 588.5,333.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4c4cd",
    d: "M 588.5,333.5 C 589.919,332.549 591.585,332.216 593.5,332.5C 593.829,346.677 593.496,360.677 592.5,374.5C 592.5,360.833 592.5,347.167 592.5,333.5C 591.167,333.5 589.833,333.5 588.5,333.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ea93a3",
    d: "M 419.5,338.5 C 433.171,338.333 446.837,338.5 460.5,339C 459.956,339.717 459.289,340.217 458.5,340.5C 445.5,339.833 432.5,339.167 419.5,338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d50738",
    d: "M 268.5,339.5 C 279.505,339.333 290.505,339.5 301.5,340C 302.126,340.75 302.626,341.584 303,342.5C 303.167,346.167 303.333,349.833 303.5,353.5C 303.604,357.947 303.104,362.28 302,366.5C 301.5,367 301,367.5 300.5,368C 289.833,368.667 279.167,368.667 268.5,368C 267.874,367.25 267.374,366.416 267,365.5C 266.333,357.833 266.333,350.167 267,342.5C 267.513,341.473 268.013,340.473 268.5,339.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d50137",
    d: "M 490.5,339.5 C 501.172,339.333 511.839,339.5 522.5,340C 523,340.5 523.5,341 524,341.5C 524.167,345.5 524.333,349.5 524.5,353.5C 524.609,358.278 524.109,362.944 523,367.5C 512.243,368.653 501.41,368.82 490.5,368C 490,367.5 489.5,367 489,366.5C 488.333,358.167 488.333,349.833 489,341.5C 489.717,340.956 490.217,340.289 490.5,339.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfc",
    d: "M 158.5,362.5 C 159.043,362.44 159.376,362.107 159.5,361.5C 145.182,360.501 130.849,360.167 116.5,360.5C 112.213,357.378 111.379,353.378 114,348.5C 114.75,347.874 115.584,347.374 116.5,347C 130.833,346.667 145.167,346.333 159.5,346C 152.833,339.333 146.167,332.667 139.5,326C 142.713,322.451 146.213,319.284 150,316.5C 157.124,322.622 163.957,329.122 170.5,336C 167.167,339.333 163.833,342.667 160.5,346C 167.5,346.333 174.5,346.667 181.5,347C 183.888,349.05 185.888,351.384 187.5,354C 175.694,366.973 163.361,379.473 150.5,391.5C 146.634,388.468 143.301,384.968 140.5,381C 145.992,374.342 151.992,368.175 158.5,362.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4c8d0",
    d: "M 116.5,360.5 C 130.849,360.167 145.182,360.501 159.5,361.5C 159.376,362.107 159.043,362.44 158.5,362.5C 144.5,361.833 130.5,361.167 116.5,360.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4c9d1",
    d: "M 426.5,367.5 C 439.5,368.167 452.5,368.833 465.5,369.5C 451.829,369.667 438.163,369.5 424.5,369C 425.044,368.283 425.711,367.783 426.5,367.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1f648b93aa742213199cbe63f6319679.svg";
export { ForwardRef as ReactComponent };